/** @format */

import axios from "axios";
import fetchJsonp from "fetch-jsonp";
import { environment } from "../env";
import { authHeader } from "./authHeader";
import { CHART_API, HISTORY_API, STORAGE_API } from "./common";
import { createApi } from "./utils";

var FormData = require("form-data");

let API = environment.API;
// const APIforS3 = environment.APIforS3;
axios.defaults.baseURL = API;
axios.defaults.headers.common.accept = "application/json";
let accessToken = window.sessionStorage.getItem("accessToken");

const SERVICE = {
  getImageBlob(image, func) {
    fetch(`${API}/downloadImage/${image}`, {
      headers: {
        ...authHeader(),
      },
    })
      .then(function (data) {
        return data.blob();
      })
      .then((blob) => {
        var img = URL.createObjectURL(blob);
        func(img);
      });
  },
  getImageCode(image, func) {
    fetch(`${API}/downloadImage/${image}`, {
      headers: {
        ...authHeader(),
      },
    })
      .then(function (data) {
        return data.blob();
      })
      .then((blob) => {
        var reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onloadend = function () {
          func(reader.result);
        };
      });
  },
  updateImageInList(image, func, ind) {
    fetch(`${API}/downloadImage/${image}`, {
      headers: {
        ...authHeader(),
      },
    })
      .then(function (data) {
        return data.blob();
      })
      .then((blob) => {
        func(URL.createObjectURL(blob), ind);
      })
      .catch(() => {});
  },
  getAdvertisements() {
    return axios.get(`${API}/getImagePath`, {
      headers: {
        ...authHeader(),
        accept: "application/json",
        "Content-Type": "application/json",
      },
    });
  },
  getDownloadSurveyReport(json) {
    return axios.post(`${API}/getDownloadSurveyReport`, json, {
      headers: {
        ...authHeader(),
        accept: "application/json",
        "Content-Type": "application/json",
      },
    });
  },
  getPendingSubscriptions() {
    return axios({
      method: "get",
      url: `${API}/channel/pendingSubscriptionRequests`,
      headers: {
        ...authHeader(),
        accept: "application/json",
        "Content-Type": "application/json",
      },
    });
  },
  getApprovedSubscriptions() {
    return axios({
      method: "get",
      url: `${API}/channel/approvedSubscriptionRequests`,
      headers: {
        ...authHeader(),
        accept: "application/json",
        "Content-Type": "application/json",
      },
    });
  },
  getRejectedSubscriptions() {
    return axios({
      method: "get",
      url: `${API}/channel/rejectedSubscriptionRequests`,
      headers: {
        ...authHeader(),
        accept: "application/json",
        "Content-Type": "application/json",
      },
    });
  },
  approveSubscription(data) {
    return axios.put(`${API}/channel/approveUserSubscription`, data, {
      headers: {
        ...authHeader(),
        accept: "application/json",
        "Content-Type": "application/json",
      },
    });
  },
  denySubscription(data) {
    return axios.put(`${API}/channel/rejectUserSubscription`, data, {
      headers: {
        ...authHeader(),
        accept: "application/json",
        "Content-Type": "application/json",
      },
    });
  },
  getCommodoties() {
    return axios({
      method: "get",
      url: `${API}/commodities`,
      headers: {
        ...authHeader(),
        accept: "application/json",
        "Content-Type": "application/json",
      },
    });
  },
  createCommodity(commodityToSave) {
    return axios.post(`${API}/commodity`, commodityToSave, {
      headers: {
        ...authHeader(),
        accept: "application/json",
        "Content-Type": "application/json",
      },
    });
  },
  updateCommodity(commodityToUpdate) {
    return axios.put(`${API}/commodity`, commodityToUpdate, {
      headers: {
        ...authHeader(),
        accept: "application/json",
        "Content-Type": "application/json",
      },
    });
  },
  deleteCommodity(commodityId) {
    return axios.delete(`${API}/commodity/${commodityId}`, {
      headers: {
        ...authHeader(),
        accept: "application/json",
        "Content-Type": "application/json",
      },
    });
  },
  getChannels() {
    return axios({
      method: "get",
      url: `${API}/channel/channels`,
      headers: {
        ...authHeader(),
        accept: "application/json",
        "Content-Type": "application/json",
      },
    });
  },
  getChannelCommodities() {
    return axios({
      method: "get",
      url: `${API}/channel/commodities`,
      headers: {
        ...authHeader(),
        accept: "application/json",
        "Content-Type": "application/json",
      },
    });
  },
  getChannelById(channelId) {
    return axios({
      method: "get",
      url: `${API}/channel/getChannel/${channelId}`,
      headers: {
        ...authHeader(),
        accept: "application/json",
        "Content-Type": "application/json",
      },
    });
  },
  getNotificationHistory() {
    return axios({
      method: "get",
      url: `${API}/notificationHistory`,
      headers: {
        ...authHeader(),
        accept: "application/json",
        "Content-Type": "application/json",
      },
    });
  },
  saveCommodityNotification(json) {
    return axios.post(`${API}/notification`, json, {
      headers: {
        ...authHeader(),
        accept: "application/json",
        "Content-Type": "application/json",
      },
    });
  },
  getChannelRegions() {
    return axios({
      method: "get",
      url: `${API}/channel/regions`,
      headers: {
        ...authHeader(),
        accept: "application/json",
        "Content-Type": "application/json",
      },
    });
  },
  saveCommodityChannel(channelData) {
    return axios.post(`${API}/channel/createChannel`, channelData, {
      headers: {
        ...authHeader(),
        accept: "application/json",
        "Content-Type": "application/json",
      },
    });
  },
  editCommodityChannel(channelData) {
    return axios.put(`${API}/channel/editChannel`, channelData, {
      headers: {
        ...authHeader(),
        accept: "application/json",
        "Content-Type": "application/json",
      },
    });
  },
  getCommodityInsightsByDate(date) {
    return axios.get(`${API}/commodityInsights/${date}`, {
      headers: {
        ...authHeader(),
        accept: "application/json",
        "Content-Type": "application/json",
      },
    });
  },
  getCommodityCommentsByDate(date) {
    return axios.get(`${API}/commodityComments/${date}`, {
      headers: {
        ...authHeader(),
        accept: "application/json",
        "Content-Type": "application/json",
      },
    });
  },
  saveInsightsData(commodityInsights) {
    return axios.put(`${API}/saveCommodityInsights`, commodityInsights, {
      headers: {
        ...authHeader(),
        accept: "application/json",
        "Content-Type": "application/json",
      },
    });
  },
  postDataPredicted(json) {
    return axios.put(`${API}/saveCommoditesPrediction?end_date=2018-09-1&user=user10`, json);
  },
  saveCommentsData(commentsData) {
    return axios.put(`${API}/saveCommodityComments`, commentsData, {
      headers: {
        ...authHeader(),
        accept: "application/json",
        "Content-Type": "application/json",
      },
    });
  },
  getQuandlData() {
    return axios.get(
      `https://www.quandl.com/api/v3/datasets/ICE/IBOV2018.json?api_key=m1vWWyg4dw_eCJzQT5nD&exclude_column_names=true&order=asc`
    );
  },
  getChartData(data) {
    return fetchJsonp(createApi(CHART_API, data), { timeout: 20000 }).then((response) => {
      return response.json();
    });
  },
  getlatestCraData(region) {
    return axios.get(`${API}/getLatestCraPrices?region_id=${region}`, {
      headers: {
        ...authHeader(),
        accept: "application/json",
        "Content-Type": "application/json",
      },
    });
  },
  getCommodtyPredictData() {
    return axios.get(`${API}/commoditesAverageData?from_date=2018-07-31&end_date=2018-09-30&commodity=Palm`);
  },
  getCommodityNews() {
    return axios({
      method: "get",
      url: `${API}/adminCommodityNews`,
      headers: {
        ...authHeader(),
        accept: "application/json",
        "Content-Type": "application/json",
      },
    });
  },
  saveCommodityNews(newsData) {
    return axios.post(`${API}/saveCommodityNews`, newsData, {
      headers: {
        ...authHeader(),
        accept: "application/json",
        "Content-Type": "application/json",
      },
    });
  },
  getUserHistoData(commodity) {
    return axios.get(`${API}/userHistogramData?from_date=2018-09-08&end_date=2018-09-08&commodity=${commodity}`, {
      headers: { Authorization: "Bearer " + accessToken },
    });
  },
  userPredictedData() {
    return axios.get(`${API}/userPredictedData/2018-09-08/user1`, {
      headers: {
        ...authHeader(),
        accept: "application/json",
        "Content-Type": "application/json",
      },
    });
  },
  uploadFile(filePayload, articleDescription, createdDate) {
    let formData = new FormData();
    formData.append("file", filePayload);
    formData.append("description", articleDescription);
    formData.append("created_date", createdDate);
    formData.append("commodity", "commodity");
    return axios.post(`${API}/commodityDocuments`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },
  getWeatherDetails(date, region) {
    return axios.get(`${API}/getWeatherDetails/${date}/${region}`, {
      headers: {
        ...authHeader(),
        accept: "application/json",
        "Content-Type": "application/json",
      },
    });
  },
  getPublishedStatus(date, region, channelId) {
    return axios.get(`${API}/publishedStatus/${date}/${region}?reportDate=${date}&channelId=${channelId}`, {
      headers: {
        ...authHeader(),
        accept: "application/json",
        "Content-Type": "application/json",
      },
    });
  },
  getEarlyMarketDetails(date, region) {
    return axios.get(`${API}/getEarlyMarketDetails/${date}/${region}`, {
      headers: {
        ...authHeader(),
        accept: "application/json",
        "Content-Type": "application/json",
      },
    });
  },
  getPreviousContent(date, region) {
    return axios.get(`${API}/getPreviousContent/${date}/${region}`, {
      headers: {
        ...authHeader(),
        accept: "application/json",
        "Content-Type": "application/json",
      },
    });
  },
  getOutsideMarkets(date, region) {
    return axios.get(`${API}/getOutsideMarkets/${date}/${region}`, {
      headers: {
        ...authHeader(),
        accept: "application/json",
        "Content-Type": "application/json",
      },
    });
  },
  getMarketOverviewDetails(date, region) {
    return axios.get(`${API}/getMarketOverviewDetails/${date}/${region}`, {
      headers: {
        ...authHeader(),
        accept: "application/json",
        "Content-Type": "application/json",
      },
    });
  },
  getAdvertisementDetails(date, region) {
    return axios.get(`${API}/getSyndicationAdvertisementBanner/${date}/${region}`, {
      headers: {
        ...authHeader(),
        accept: "application/json",
        "Content-Type": "application/json",
      },
    });
  },
  getEconomicIndicatorsDetails(date, region) {
    return axios.get(`${API}/getEconomicIndicators/${date}/${region}`, {
      headers: {
        ...authHeader(),
        accept: "application/json",
        "Content-Type": "application/json",
      },
    });
  },
  saveSyndicationContent(pushData) {
    return axios.post(`${API}/saveSyndicationContent`, pushData, {
      headers: {
        ...authHeader(),
        accept: "application/json",
        "Content-Type": "application/json",
      },
    });
  },
  pushTemplate(pushData) {
    return axios.post(`${API}/sendEmailNotification`, pushData, {
      headers: {
        ...authHeader(),
        accept: "application/json",
        "Content-Type": "application/json",
      },
    });
  },
  getPricedata(data, source) {
    if (source === "cra") {
      return axios.get(createApi(`${API}/getCraPricesHistory`, data), {
        headers: {
          ...authHeader(),
          accept: "application/json",
          "Content-Type": "application/json",
        },
      });
    }
    return fetchJsonp(createApi(HISTORY_API, data), { timeout: 20000 }).then((response) => {
      return response.json();
    });
  },
  getCraPriceHistory(data) {
    return axios.get(createApi(`${API}/getCraPricesHistory`, data), {
      headers: {
        ...authHeader(),
        accept: "application/json",
        "Content-Type": "application/json",
      },
    });
  },
  postImageToS3(file) {
    let formData = new FormData();
    formData.append("file", file);
    return axios.post(`${API}/uploadImage`, formData, {
      headers: {
        ...authHeader(),
        "content-type": "multipart/form-data",
      },
    });
  },
  postImageToMiAppStorage(file, uploadProgressCallback = () => {}) {
    let formData = new FormData();
    formData.append("file", file);
    return axios.post(`${STORAGE_API}/uploadImage`, formData, {
      headers: {
        ...authHeader(),
        "content-type": "multipart/form-data",
      },
      onUploadProgress: function (uploadEvent) {
        const { loaded, total } = uploadEvent;
        uploadProgressCallback(total, loaded);
      },
    });
  },
  deleteCommodityNews(id) {
    return axios.put(`${API}/deleteCommodityNews/${id}`, null, {
      headers: {
        ...authHeader(),
        accept: "application/json",
        "Content-Type": "application/json",
      },
    });
  },
  getGridData() {
    return axios.get(`${API}/getAllUserDataReport`, {
      headers: {
        ...authHeader(),
        accept: "application/json",
        "Content-Type": "application/json",
      },
    });
  },
  sendAdDetails(region, data) {
    return axios.put(`${API}/advertisementbanners/${region}`, data, {
      headers: {
        ...authHeader(),
        accept: "application/json",
        "Content-Type": "application/json",
      },
    });
  },
  sendVersionDetails(versionData) {
    return axios.post(`${API}/createProductFeatures`, versionData, {
      headers: {
        ...authHeader(),
        accept: "application/json",
        "Content-Type": "application/json",
      },
    });
  },
  getVersionDetails(version) {
    return axios.get(`${API}/productFeatures/${version}`, {
      headers: {
        ...authHeader(),
        accept: "application/json",
        "Content-Type": "application/json",
      },
    });
  },
  getSurveyQuestions() {
    return axios.get(`${API}/getWebUIQuestionnaire`, {
      headers: {
        ...authHeader(),
        accept: "application/json",
        "Content-Type": "application/json",
      },
    });
  },
  deleteQuestion(questionId) {
    return axios.put(`${API}/${questionId}`, null, {
      headers: {
        ...authHeader(),
        accept: "application/json",
        "Content-Type": "application/json",
      },
    });
  },
  postSurveyQuestion(question) {
    return axios.post(`${API}/createQuestionnaire`, question, {
      headers: {
        ...authHeader(),
        accept: "application/json",
        "Content-Type": "application/json",
      },
    });
  },
  getSurveyQuestionPoll(requestedQuestionIDs) {
    return axios.post(`${API}/getSurveyReport`, requestedQuestionIDs, {
      headers: {
        ...authHeader(),
        accept: "application/json",
        "Content-Type": "application/json",
      },
    });
  },
  getAllAdminList() {
    return axios.get(`${API}/accountManager`, {
      headers: {
        ...authHeader(),
        accept: "application/json",
        "Content-Type": "application/json",
      },
    });
  },
  deleteAdmin(id) {
    return axios.put(`${API}/deleteAccountManager/${id}`, null, {
      headers: {
        ...authHeader(),
        accept: "application/json",
        "Content-Type": "application/json",
      },
    });
  },
  addAdmin(adminObj) {
    return axios.post(`${API}/createAccountManager`, adminObj, {
      headers: {
        ...authHeader(),
        accept: "application/json",
        "Content-Type": "application/json",
      },
    });
  },
  editAdmin(adminObj) {
    return axios.put(`${API}/updateAccountManager`, adminObj, {
      headers: {
        ...authHeader(),
        accept: "application/json",
        "Content-Type": "application/json",
      },
    });
  },
  mapUser(requestObj) {
    return axios.post(`${API}/customerToManagerMapping`, requestObj, {
      headers: {
        ...authHeader(),
        accept: "application/json",
        "Content-Type": "application/json",
      },
    });
  },
  //user registration
  getRegionCountry() {
    return axios.get(`${API}/regionAndCountries`);
  },
  getRegisteredUsers() {
    return axios.get(`${API}/users`, {
      headers: {
        ...authHeader(),
        accept: "application/json",
        "Content-Type": "application/json",
      },
    });
  },
  deActivateUser(userId) {
    return axios.delete(`${API}/deleteUser/${userId}`, {
      headers: {
        ...authHeader(),
        accept: "application/json",
        "Content-Type": "application/json",
      },
    });
  },
  AuthenticateUser(requestObj) {
    return axios.post(`${API}/channel/approveUser`, requestObj, {
      headers: {
        ...authHeader(),
        accept: "application/json",
        "Content-Type": "application/json",
      },
    });
  },
  createUser(userObj) {
    return axios.post(`${API}/createUser`, userObj, {
      headers: {
        // ...authHeader(),
        accept: "application/json",
        "Content-Type": "application/json",
      },
    });
  },
  activationAPI(activation) {
    return axios.post(`${API}/userActivity`, activation, {
      headers: {
        ...authHeader(),
        accept: "application/json",
        "Content-Type": "application/json",
      },
    });
  },
  //poll
  getOngoingPolls() {
    return axios.get(`${API}/getOnGoingSurveyPoll`, {
      headers: {
        ...authHeader(),
        accept: "application/json",
        "Content-Type": "application/json",
      },
    });
  },

  getUpcomingPolls() {
    return axios.get(`${API}/getUpcomingSurveyPoll`, {
      headers: {
        ...authHeader(),
        accept: "application/json",
        "Content-Type": "application/json",
      },
    });
  },

  getHistoryPolls() {
    return axios.get(`${API}/getHistorySurveyReport`, {
      headers: {
        ...authHeader(),
        accept: "application/json",
        "Content-Type": "application/json",
      },
    });
  },

  publishPolls(data) {
    return axios.post(`${API}/updatePublishSurveyFlag`, data, {
      headers: {
        ...authHeader(),
        accept: "application/json",
        "Content-Type": "application/json",
      },
    });
  },

  getSurveyReport(data) {
    return axios.post(`${API}/getSurveyReport`, data, {
      headers: {
        ...authHeader(),
        accept: "application/json",
        "Content-Type": "application/json",
      },
    });
  },

  saveorUpdateSurvey(polls) {
    return axios.post(`${API}/saveOrUpdateSurveyQuestionnaire`, polls, {
      headers: {
        ...authHeader(),
        accept: "application/json",
        "Content-Type": "application/json",
      },
    });
  },

  UpdateSurveyDate(data) {
    return axios.post(`${API}/UpdateSurveyDetails`, data, {
      headers: {
        ...authHeader(),
        accept: "application/json",
        "Content-Type": "application/json",
      },
    });
  },

  deleteSurvey(surveyId) {
    return axios.put(
      `${API}/deleteSurvey/${surveyId}`,
      {},
      {
        headers: {
          ...authHeader(),
          accept: "application/json",
          "Content-Type": "application/json",
        },
      }
    );
  },

  deleteOption(optionid) {
    return axios.put(
      `${API}/deleteOption/${optionid}`,
      {},
      {
        headers: {
          ...authHeader(),
          accept: "application/json",
          "Content-Type": "application/json",
        },
      }
    );
  },

  deletequestion(qid) {
    return axios.put(
      `${API}/deleteQuestion/${qid}`,
      {},
      {
        headers: {
          ...authHeader(),
          accept: "application/json",
          "Content-Type": "application/json",
        },
      }
    );
  },

  getSyndication(date, regionId, channelId) {
    return axios.get(`${API}/syndicationContent?regionId=${regionId}&reportDate=${date}&channelId=${channelId}`, {
      headers: {
        ...authHeader(),
        accept: "application/json",
        "Content-Type": "application/json",
      },
    });
  },

  // CHANNEL MERCHANTS
  createChannelMerchants(merchants) {
    return axios.post(`${API}/channel/channelMerchants`, merchants, {
      headers: {
        ...authHeader(),
        accept: "application/json",
        "Content-Type": "application/json",
      },
    });
  },
  getChannelMerchants() {
    return axios.get(`${API}/channel/channelMerchants`, {
      headers: {
        ...authHeader(),
        accept: "application/json",
        "Content-Type": "application/json",
      },
    });
  },
  
  // CRA COMMODITIES
  cra: {
    getCraCommodities() {
      return axios({
        method: "get",
        url: `${API}/craCommodities`,
        headers: {
          ...authHeader(),
          accept: "application/json",
          "Content-Type": "application/json",
        },
      });
    },
    updateCraCommodity(commodityToUpdate) {
      return axios.put(`${API}/craCommodity`, commodityToUpdate, {
        headers: {
          ...authHeader(),
          accept: "application/json",
          "Content-Type": "application/json",
        },
      });
    },
    createCraCommodity(commodityToSave) {
      return axios.post(`${API}/craCommodity`, commodityToSave, {
        headers: {
          ...authHeader(),
          accept: "application/json",
          "Content-Type": "application/json",
        },
      });
    },
    deleteCraCommodity(commodityId) {
      return axios.delete(`${API}/deleteCraCommodity/${commodityId}`, {
        headers: {
          ...authHeader(),
          accept: "application/json",
          "Content-Type": "application/json",
        },
      });
    },
    hideUnHideCraCommodity(id, action) {
      return axios.put(`${API}/craCommodityActivity?id=${id}&action=${action}`, null, {
        headers: {
          ...authHeader(),
          accept: "application/json",
          "Content-Type": "application/json",
        },
      });
    },
  },
};

export default SERVICE;
